import React, { useContext, useEffect, useState } from "react";
import IconDownloadButton from "../../../components/IconDownloadButton";
import { TbEdit } from "react-icons/tb";
import IOSSwitch from "../toggle";
import InputComponent from "./Components/InputComponent";
import axios from "axios";
import { sideBarContext } from "../../../App";

function LtvConfiguration() {
  const token = localStorage.getItem("token");
  const [type, setType] = useState("od");
  const [toggleDetails, setToggleDetails] = useState([]);
  const [toggleModal, setToggleModal] = useState(false);
  const { expanded } = useContext(sideBarContext);

  const [ltvConfigData, setLtvConfigData] = useState([]);

  const getLtvConfiguration = async () => {
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/ltv_configurations/get_ltv_configurations?loan_type=${type}`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      if (res?.data?.status) {
        setLtvConfigData(res?.data?.configurations);
      }
    } catch (error) {}
  };

  const updateLtvConfiguration = async (flag, value, percent) => {
    let params = {
      loan_type: value.loan_type,
      form: value.form,
      rta: value.rta,
      debt: flag === "debt" && percent ? Number(percent) : value.debt,
      equities:
        flag === "equities" && percent ? Number(percent) : value.equities,
      hybrid: flag === "hybrid" && percent ? Number(percent) : value.hybrid,
      other_funds:
        flag === "other_funds" && percent ? Number(percent) : value.other_funds,
      finsire_dynamic_model:
        flag === "switch" ? Boolean(percent) : value.finsire_dynamic_model,
    };
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/ltv_configurations/update`,
        method: "PUT",
        headers: { Authorization: token },
        data: params,
      };
      const res = await axios(options);
      if (res?.data?.status) {
        getLtvConfiguration();
      }
    } catch (error) {}
  };

  useEffect(() => {
    getLtvConfiguration();
  }, [type]);

  return (
    <div
      className={`bg-[#f1f1f6] ${
        expanded ? "w-[calc(100%-240px)]" : "w-[calc(100%-90px)]"
      } min-h-[100vh] max-h-full`}
    >
      <div
        className={`w-full bg-[#f1f1f6] px-[16px] pt-[16px] pb-4 relative h-full`}
      >
        <div className="w-full bg-white h-fit rounded-lg p-4 mb-4">
          <p className=" text-xl font-semibold">LTV Configuration</p>
          <div className="flex items-center text-sm gap-8">
            <p
              className={`${
                type === "od"
                  ? "border-b-[3px] border-b-solid border-b-[#00394D] font-bold"
                  : "font-medium"
              } py-2 cursor-pointer text-[#262626] text-sm`}
              onClick={() => {
                setType("od");
              }}
            >
              Overdraft Loans
            </p>
            <p
              className={`${
                type === "term_loan"
                  ? "border-b-[3px] border-b-solid border-b-[#00394D] font-bold"
                  : "font-medium"
              } py-2 cursor-pointer text-[#262626] text-sm`}
              onClick={() => {
                setType("term_loan");
              }}
            >
              Term Loans
            </p>
          </div>
        </div>
        <div className="pt-2 w-full bg-white p-4 rounded-lg">
          <p className=" text-xl font-semibold">SOA Form-Mutual Funds</p>
          <div className="flex flex-row justify-between items-center gap-4">
            {ltvConfigData &&
              ltvConfigData.length > 0 &&
              ltvConfigData.map((item) => {
                return (
                  <div
                    className="flex flex-col border border-solid border-[#E6EBED] rounded-lg p-4 mt-4"
                    key={item.id}
                  >
                    <div className="flex flex-row justify-between items-center">
                      <p className="text-sm font-medium">
                        {item.rta === "cams"
                          ? "CAMS"
                          : item.rta === "kfin"
                          ? "Kfintech"
                          : "MFCentral"}{" "}
                        funds
                      </p>
                      <button>
                        {" "}
                        <IconDownloadButton
                          bg="bg-[#00394d]"
                          iconColor={"text-white"}
                        />
                      </button>
                    </div>
                    <div className="my-4 h-[1px] w-full border border-solid border-[#E6EBED]"></div>
                    <InputComponent
                      label="Debt funds"
                      value={item}
                      symbol={"%"}
                      first={true}
                      updateLtvConfiguration={updateLtvConfiguration}
                      flag={"debt"}
                    />
                    <InputComponent
                      label="Hybrid funds"
                      value={item}
                      symbol={"%"}
                      updateLtvConfiguration={updateLtvConfiguration}
                      flag={"hybrid"}
                    />
                    <InputComponent
                      label="Equity funds"
                      value={item}
                      symbol={"%"}
                      updateLtvConfiguration={updateLtvConfiguration}
                      flag={"equities"}
                    />
                    <InputComponent
                      label="Other funds"
                      value={item}
                      symbol={"%"}
                      updateLtvConfiguration={updateLtvConfiguration}
                      flag={"other_funds"}
                    />
                    <div className="flex flex-row justify-between items-center mt-8">
                      <p className="text-xs font-medium text-[#8B8B8B]">
                        Finsire Dynamic Model
                      </p>
                      <IOSSwitch
                        checked={item.finsire_dynamic_model}
                        onChange={(e) => {
                          updateLtvConfiguration(
                            "switch",
                            item,
                            e.target.checked
                          );
                        }}
                        // onClick={() => {
                        //   if (toggleDetails.includes("1")) {
                        //     let temp = [...toggleDetails];
                        //     temp = temp.filter((item) => item !== "1");
                        //     setToggleDetails(temp);
                        //   } else {
                        //     let temp = [...toggleDetails];
                        //     temp.push("1");
                        //     setToggleDetails(temp);
                        //   }
                        // }}
                      />
                    </div>
                    <div className="mt-8 bg-[#EEF7FF] rounded-lg pr-3 py-3 pl-6">
                      <ol className="text-xs font-medium text-[#8B8B8B] list-decimal">
                        <li>
                          The LTV of any fund will be the lower of the limit set
                          by the lender or Finsire's dynamic model value.
                        </li>
                        <li className=" mt-1">
                          The dynamic model uses AI/ML to provide a higher
                          margin of safety on top of the limit set by lender .
                        </li>
                      </ol>
                    </div>
                  </div>
                );
              })}

            {/* <div className="flex flex-col border border-solid border-[#E6EBED] rounded-lg p-4 mt-4">
              <div className="flex flex-row justify-between items-center">
                <p className="text-sm font-medium">Kfintech funds</p>
                <button>
                  {" "}
                  <IconDownloadButton
                    bg="bg-[#00394d]"
                    iconColor={"text-white"}
                  />
                </button>
              </div>
              <div className="my-4 h-[1px] w-full border border-solid border-[#E6EBED]"></div>
              <InputComponent
                label="Debt funds"
                value="80"
                symbol={"%"}
                first={true}
              />
              <InputComponent label="Hybrid funds" value="65" symbol={"%"} />
              <InputComponent label="Equity funds" value="50" symbol={"%"} />
              <InputComponent label="Other funds" value="45" symbol={"%"} />
              <div className="flex flex-row justify-between items-center mt-8">
                <p className="text-xs font-medium text-[#8B8B8B]">
                  Finsire Dynamic Model
                </p>
                <IOSSwitch
                  checked={toggleDetails.includes("2")}
                  onClick={() => {
                    if (toggleDetails.includes("2")) {
                      let temp = [...toggleDetails];
                      temp = temp.filter((item) => item !== "2");
                      setToggleDetails(temp);
                    } else {
                      let temp = [...toggleDetails];
                      temp.push("2");
                      setToggleDetails(temp);
                    }
                  }}
                />
              </div>
              <div className="mt-8 bg-[#EEF7FF] rounded-lg pr-3 py-3 pl-6">
                <ol className="text-xs font-medium text-[#8B8B8B] list-decimal">
                  <li>
                    The LTV of any fund will be the lower of the limit set by
                    the lender or Finsire's dynamic model value.
                  </li>
                  <li className=" mt-1">
                    The dynamic model uses AI/ML to provide a higher margin of
                    safety on top of the limit set by lender .
                  </li>
                </ol>
              </div>
            </div>

            <div className="flex flex-col border border-solid border-[#E6EBED] rounded-lg p-4 mt-4">
              <div className="flex flex-row justify-between items-center">
                <p className="text-sm font-medium">MFCentral funds</p>
                <button>
                  {" "}
                  <IconDownloadButton
                    bg="bg-[#00394d]"
                    iconColor={"text-white"}
                  />
                </button>
              </div>
              <div className="my-4 h-[1px] w-full border border-solid border-[#E6EBED]"></div>
              <InputComponent
                label="Debt funds"
                value="80"
                symbol={"%"}
                first={true}
              />
              <InputComponent label="Hybrid funds" value="65" symbol={"%"} />
              <InputComponent label="Equity funds" value="50" symbol={"%"} />
              <InputComponent label="Other funds" value="45" symbol={"%"} />
              <div className="flex flex-row justify-between items-center mt-8">
                <p className="text-xs font-medium text-[#8B8B8B]">
                  Finsire Dynamic Model
                </p>
                <IOSSwitch
                  checked={toggleDetails.includes("3")}
                  onClick={() => {
                    if (toggleDetails.includes("3")) {
                      let temp = [...toggleDetails];
                      temp = temp.filter((item) => item !== "3");
                      setToggleDetails(temp);
                    } else {
                      let temp = [...toggleDetails];
                      temp.push("3");
                      setToggleDetails(temp);
                    }
                  }}
                />
              </div>
              <div className="mt-8 bg-[#EEF7FF] rounded-lg pr-3 py-3 pl-6">
                <ol className="text-xs font-medium text-[#8B8B8B] list-decimal">
                  <li>
                    The LTV of any fund will be the lower of the limit set by
                    the lender or Finsire's dynamic model value.
                  </li>
                  <li className=" mt-1">
                    The dynamic model uses AI/ML to provide a higher margin of
                    safety on top of the limit set by lender .
                  </li>
                </ol>
              </div>
            </div> */}
          </div>

          {/* Part 2 */}

          {/* <p className=" text-xl font-semibold mt-8">Demat Form-Mutual funds</p>
          <div className="flex flex-row justify-start items-center gap-4">
            <div className="flex flex-col border border-solid border-[#E6EBED] rounded-lg w-[387px] p-4 mt-4">
              <div className="flex flex-row justify-between items-center">
                <p className="text-sm font-medium">NSDL funds</p>
                <button>
                  {" "}
                  <IconDownloadButton
                    bg="bg-[#00394d]"
                    iconColor={"text-white"}
                  />
                </button>
              </div>
              <div className="my-4 h-[1px] w-full border border-solid border-[#E6EBED]"></div>
              <InputComponent
                label="Debt funds"
                value="80"
                symbol={"%"}
                first={true}
              />
              <InputComponent label="Hybrid funds" value="65" symbol={"%"} />
              <InputComponent label="Equity funds" value="50" symbol={"%"} />
              <InputComponent label="Other funds" value="45" symbol={"%"} />
              <div className="flex flex-row justify-between items-center mt-8">
                <p className="text-xs font-medium text-[#8B8B8B]">
                  Finsire Dynamic Model
                </p>
                <IOSSwitch
                  checked={toggleDetails.includes("4")}
                  onClick={() => {
                    if (toggleDetails.includes("4")) {
                      let temp = [...toggleDetails];
                      temp = temp.filter((item) => item !== "4");
                      setToggleDetails(temp);
                    } else {
                      let temp = [...toggleDetails];
                      temp.push("4");
                      setToggleDetails(temp);
                    }
                  }}
                />
              </div>
              <div className="mt-8 bg-[#EEF7FF] rounded-lg pr-3 py-3 pl-6">
                <ol className="text-xs font-medium text-[#8B8B8B] list-decimal">
                  <li>
                    The LTV of any fund will be the lower of the limit set by
                    the lender or Finsire's dynamic model value.
                  </li>
                  <li className=" mt-1">
                    The dynamic model uses AI/ML to provide a higher margin of
                    safety on top of the limit set by lender .
                  </li>
                </ol>
              </div>
            </div>

            <div className="flex flex-col border border-solid border-[#E6EBED] rounded-lg w-[387px] p-4 mt-4">
              <div className="flex flex-row justify-between items-center">
                <p className="text-sm font-medium">CDSL funds</p>
                <button>
                  {" "}
                  <IconDownloadButton
                    bg="bg-[#00394d]"
                    iconColor={"text-white"}
                  />
                </button>
              </div>
              <div className="my-4 h-[1px] w-full border border-solid border-[#E6EBED]"></div>
              <InputComponent
                label="Debt funds"
                value="80"
                symbol={"%"}
                first={true}
              />
              <InputComponent label="Hybrid funds" value="65" symbol={"%"} />
              <InputComponent label="Equity funds" value="50" symbol={"%"} />
              <InputComponent label="Other funds" value="45" symbol={"%"} />
              <div className="flex flex-row justify-between items-center mt-8">
                <p className="text-xs font-medium text-[#8B8B8B]">
                  Finsire Dynamic Model
                </p>
                <IOSSwitch
                  checked={toggleDetails.includes("5")}
                  onClick={() => {
                    if (toggleDetails.includes("5")) {
                      let temp = [...toggleDetails];
                      temp = temp.filter((item) => item !== "5");
                      setToggleDetails(temp);
                    } else {
                      let temp = [...toggleDetails];
                      temp.push("5");
                      setToggleDetails(temp);
                    }
                  }}
                />
              </div>
              <div className="mt-8 bg-[#EEF7FF] rounded-lg pr-3 py-3 pl-6">
                <ol className="text-xs font-medium text-[#8B8B8B] list-decimal">
                  <li>
                    The LTV of any fund will be the lower of the limit set by
                    the lender or Finsire's dynamic model value.
                  </li>
                  <li className=" mt-1">
                    The dynamic model uses AI/ML to provide a higher margin of
                    safety on top of the limit set by lender .
                  </li>
                </ol>
              </div>
            </div>
          </div> */}

          {/* Part 3 */}

          {/* <p className=" text-xl font-semibold mt-8">Demat Form-Equities</p>
          <div className="flex flex-row justify-start items-center gap-4">
            <div className="flex flex-col border border-solid border-[#E6EBED] rounded-lg p-4 mt-4 w-[387px]">
              <div className="flex flex-row justify-between items-center">
                <p className="text-sm font-medium">NSDL funds</p>
                <button>
                  {" "}
                  <IconDownloadButton
                    bg="bg-[#00394d]"
                    iconColor={"text-white"}
                  />
                </button>
              </div>
              <div className="my-4 h-[1px] w-full border border-solid border-[#E6EBED]"></div>
              <InputComponent
                label="Large Cap"
                value="80"
                symbol={"%"}
                first={true}
              />
              <InputComponent label="Mid Cap" value="65" symbol={"%"} />
              <InputComponent label="Small Cap" value="50" symbol={"%"} />
              <div className="flex flex-row justify-between items-center mt-8">
                <p className="text-xs font-medium text-[#8B8B8B]">
                  Finsire Dynamic Model
                </p>
                <IOSSwitch
                  checked={toggleDetails.includes("6")}
                  onClick={() => {
                    if (toggleDetails.includes("6")) {
                      let temp = [...toggleDetails];
                      temp = temp.filter((item) => item !== "6");
                      setToggleDetails(temp);
                    } else {
                      let temp = [...toggleDetails];
                      temp.push("6");
                      setToggleDetails(temp);
                    }
                  }}
                />
              </div>
              <div className="mt-8 bg-[#EEF7FF] rounded-lg pr-3 py-3 pl-6">
                <ol className="text-xs font-medium text-[#8B8B8B] list-decimal">
                  <li>
                    The LTV of any fund will be the lower of the limit set by
                    the lender or Finsire's dynamic model value.
                  </li>
                  <li className=" mt-1">
                    The dynamic model uses AI/ML to provide a higher margin of
                    safety on top of the limit set by lender .
                  </li>
                </ol>
              </div>
            </div>

            <div className="flex flex-col border border-solid border-[#E6EBED] rounded-lg p-4 mt-4 w-[387px]">
              <div className="flex flex-row justify-between items-center">
                <p className="text-sm font-medium">CDSL funds</p>
                <button>
                  {" "}
                  <IconDownloadButton
                    bg="bg-[#00394d]"
                    iconColor={"text-white"}
                  />
                </button>
              </div>
              <div className="my-4 h-[1px] w-full border border-solid border-[#E6EBED]"></div>
              <InputComponent
                label="Large Cap"
                value="80"
                symbol={"%"}
                first={true}
              />
              <InputComponent label="Mid Cap" value="65" symbol={"%"} />
              <InputComponent label="Small Cap" value="50" symbol={"%"} />
              <div className="flex flex-row justify-between items-center mt-8">
                <p className="text-xs font-medium text-[#8B8B8B]">
                  Finsire Dynamic Model
                </p>
                <IOSSwitch
                  checked={toggleDetails.includes("7")}
                  onClick={() => {
                    if (toggleDetails.includes("7")) {
                      let temp = [...toggleDetails];
                      temp = temp.filter((item) => item !== "7");
                      setToggleDetails(temp);
                    } else {
                      let temp = [...toggleDetails];
                      temp.push("7");
                      setToggleDetails(temp);
                    }
                  }}
                />
              </div>
              <div className="mt-8 bg-[#EEF7FF] rounded-lg pr-3 py-3 pl-6">
                <ol className="text-xs font-medium text-[#8B8B8B] list-decimal">
                  <li>
                    The LTV of any fund will be the lower of the limit set by
                    the lender or Finsire's dynamic model value.
                  </li>
                  <li className=" mt-1">
                    The dynamic model uses AI/ML to provide a higher margin of
                    safety on top of the limit set by lender .
                  </li>
                </ol>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default LtvConfiguration;
